import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ClarityService } from './services/clarity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'adhd-app';

  constructor(
    private clarityService: ClarityService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Initialize Clarity (only runs on production/UAT — disabled on local dev)
    this.clarityService.init();

    // Track every page navigation — stores the live URL in Clarity
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const fullUrl = window.location.href;
        this.clarityService.setTag('page_url', fullUrl);
        this.clarityService.setTag('page_path', event.urlAfterRedirects);
      });
  }
}
